import { Injectable } from 'angular-ts-decorators';

import { never, Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Service that expose scope events as streams
 */
@Injectable('scopeStreams')
export class ScopeStreams {
  constructor() {
    'ngInject';
  }

  /**
   * @param {object} scope
   * angular scope for which end we wait
   * Returns observable when the scope is destroyed
   * @return {Observable}
   * Observable that emits once, as soon as scope is destroyed.
   */
  isDestroyed(scope?: ng.IScope): Observable<any> {
    if (!scope || !angular.isFunction(scope.$on)) {
      return never();
    }

    const destroySubject: Subject<any> = new Subject<any>();

    scope.$on('$destroy', () => {
      destroySubject.next(undefined);
    });

    return destroySubject.asObservable().pipe(take(1));
  }
}
